// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2ytSF","header":"Messages_header__1EOp0"};